import React from 'react';
import { useRoutes } from 'react-router-dom';
import routes from './routes';

function Index() {
    return <>{useRoutes(routes())}</>;
}

export default Index;
